var __jsx = React.createElement;
import React from "react";
import Modal from "../common/Modal";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
import { useTranslation } from "react-i18next";
import useMedia, { MediaSizes } from "../../hooks/useMedia";
import Store from "../../utils/Store";
import classNames from "classnames";
import getEnv from "../../utils/getEnv";
var ParentModal = function ParentModal(_ref) {
  var children = _ref.children,
    closePopup = _ref.closePopup,
    hasCurrentPatient = _ref.hasCurrentPatient,
    isLoading = _ref.isLoading;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isMobile = useMedia([MediaSizes.MOBILE], [true], false) && !hasCurrentPatient;
  var disableScanUpload = getEnv("NEXT_PUBLIC_DISABLE_SCAN_UPLOAD") === "true";
  var onPressClose = function onPressClose() {
    trackEvent(MIXPANEL_EVENTS.DICOM_UPLOAD_MODAL_CLOSED);
    closePopup();
    Store.update(function (s) {
      // eslint-disable-next-line no-param-reassign
      s.uploadModal = {
        isOpen: false,
        hasCurrentPatient: false
      };
    });
  };
  if (isMobile) {
    return /*#__PURE__*/React.createElement("div", {
      className: "dark:text-gray-200 h-full flex flex-col overflow-auto"
    }, children);
  } else {
    return /*#__PURE__*/React.createElement(Modal, {
      show: true,
      onClose: onPressClose,
      isLoading: isLoading,
      title: t(hasCurrentPatient ? "add_scans_patient" : "add_patient_scans"),
      className: classNames("w-full sm:w-7/12 3xl:w-5/12 sm:!bg-gray-200 !bg-gray-900 sm:dark:!bg-gray-800 h-[80%] flex flex-col sm:h-auto", {
        "!w-1/3": disableScanUpload && !hasCurrentPatient
      })
    }, /*#__PURE__*/React.createElement(React.Fragment, null, children));
  }
};
export default ParentModal;